/* eslint-disable vars-on-top */
(function() {
  'use strict';

  angular
    .module('traineeWebApp.dashboard')
    .controller('DashboardCtrl', DashboardCtrl);

  DashboardCtrl.$inject = ['$scope', 'dashboardResource', 'Auth', '$location', '$modal', 'serviceLocator', '$window', 'dashboardHelper',
    'trackingService', 'dashboardStoreService', 'Utils', '$routeParams', '$rootScope',
    'SpinnerHelper', 'Sension', '$timeout', 'MobileHelper', 'mtypes', 'gettextCatalog', 'gettext',
    'translationService', 'sprintfService', 'AccountService', 'QuizAnswerStorage', '$injector', '$interval',
    'sensionRepository'];

  function DashboardCtrl($scope, dashboardResource, Auth, $location, $modal, serviceLocator, $window, dashboardHelper,
                         trackingService, dashboardStoreService, Utils, $routeParams, $rootScope,
                         SpinnerHelper, Sension, $timeout, MobileHelper, mtypes, gettextCatalog, gettext,
                         translationService, sprintfService, AccountService, QuizAnswerStorage, $injector, $interval,
                         sensionRepository) {
    // if you want override hammer default options in click
    // if you say prevent_default to true we cant scroll
    $scope.hmOptions = {
      // eslint-disable-next-line camelcase
      prevent_default: false
    };

    gettext('module');
    gettext('course');
    gettext('Review Module');
    gettext('Review Course');
    gettext('Resume Module');
    gettext('Resume Course');
    gettext('Enter first name');
    gettext('Enter last name');
    gettext('Enter email');
    gettext('Enter username');
    gettext('Confirm new password');
    gettext('Enter new password');

    var AuthService = null;
    try {
      AuthService = $injector.get('AuthService');
    } catch (err) {
      // Ignore for mf-trainee-web.
    }

    var timers = {};
    var translate = translationService.sprintf;
    var sprintf = sprintfService.sprintf;
    var selectedLanguage = translationService.selectedLanguage;
    var expandedCourseIds = [];
    var updateDashPromise;
    var gradeStatusClass = {
      passed: 'passed',
      failed: 'failed',
      notapplicable: 'fa fa-check checkMark'
    };
    var dashboardConfig = {
      cModuleDetailView: {
        noCModuleView: 'dashboard/noCModuleFoundView.html',
        detailView: 'dashboard/cModuleDetailView.html'
      }
    };
    var getAccountsURL = '/mm/account/associatedAccounts';
    var hasNewCourse = true;
    var dashLoad;
    var accountInfoDereg;

    $scope.originalCModuleList = [];
    $scope.currentState = 'all';
    $scope.traineeCModuleList = [];
    $scope.unfilteredTraineeCModuleList = [];
    $scope.selectedCModule = null;
    $scope.selectedCourse = null;
    $scope.selectedCatalog = null;
    $scope.savedSelectedCModule = null;
    $scope.viewingCourseCModuleList = false;
    $scope.viewingCModuleInCourse = false;
    $scope.viewingCatalogCModuleList = false;
    $scope.viewingCModuleInCatalog = false;
    $scope.viewingCatalogList = false;
    $scope.trainerDashboardUrl = serviceLocator.dashboardUrl();

    $scope.viewState = {
      invited: {
        status: gettext('Not Started')
      },
      started: {
        status: gettext('In Progress')
      },
      missedcompletiondeadline: {
        status: gettext('Missed Deadline')
      },
      completed: {
        status: gettext('Completed')
      },
      search: {
        typeFilter: 'all'
      },
      viewPreference: {
        typeFilter: 'all'
      },
      certificateAvailable: true,
      allCModuleCount: 0,
      invitedCModuleCount: 0,
      completedCModuleCount: 0,
      showDeadline: false,
      showScore: false,
      showScorePercent: false,
      showPassingScore: false,
      page: {
        background: '#def2f8',
        name: 'cModule',
        header: {
          text: gettext('My Courses'),
          buttonText: gettext('Course Catalog')
        }
      },
      buttonText: gettext('Get Started'),
      course: {
        numOfCompletedCModule: 0,
        totalCModules: 0
      },
      style: {
        cModuleListTopValue: '90px',
        cModuleListBottomValue: '0'
      },
      showDrop: false,
      showRetake: false,
      showCertificate: false,
      showCModuleActionButton: true,
      missedDeadline: false,
      trainerImageUrl: '',
      orderEnforced: false,
      failureEnforced: false,
      alteredAfterCompletionMessage: false,
      completionDeadline: null,
      isLoading: true,
      hideMindflashBranding: true,
      showLanguageSelector: false,
      consoleIntegrationEnabled: false,
      headerColor: {
        background: '#FFF',
        link: '#428bca',
        text: '#000'
      },
      catalog: {
        selected: {},
        thumbUrl: 'images/catalog_thumbnail.png',
        showDeadlineMessage: false,
        isLoading: true
      },
      searchCriteria: null,
      showCatalogBackButton: false,
      showCatalogListInfo: false,
      showToggleButton: false,
      showSectionHeader: true,
      showCModuleStateView: true,
      showNoCModuleMessage: false
    };

    gettextCatalog.setCurrentLanguage(selectedLanguage() || 'en');

    $scope.languageModel = {
      selectedLanguage: gettextCatalog.currentLanguage,
      languages: []
    };

    function updateModels(originalItems, newItems) {
      var item;
      var oldItem;

      if (originalItems.length > newItems.length) {
        originalItems.length = newItems.length;
      }

      for (var i = 0; i < newItems.length; i++) {
        item = newItems[i];
        oldItem = originalItems[i];

        if (!oldItem) {
          originalItems[i] = item;
          // eslint-disable-next-line no-continue
          continue;
        }

        // TODO: Iverson investigate issue from refactor
        if (item.cModules) {
          oldItem.cModules = oldItem.cModules || [];
          updateModels(oldItem.cModules, item.cModules);
          delete item.cModules;
        } else {
          delete oldItem.cModules;
        }

        if (item.cModules) {
          oldItem.cModules = oldItem.cModules || [];
          updateModels(oldItem.cModules, item.cModules, 'id');
          delete item.cModules;
        } else {
          delete oldItem.cModules;
        }

        _.extend(oldItem, item);
      }
    }

    dashLoad = dashboardResource.getTraineeDashboardInfoMM;

    // TODO: Iverson investigate issue from refactor
    function updateDash() {
      dashLoad(function(result) {
        var selectedCModuleId = $scope.selectedCModule && $scope.selectedCModule.id;
        var selectedCourseId = $scope.selectedCourse && $scope.selectedCourse.id;
        var selectedCatalogId = null;

        updateModels($scope.originalCModuleList, result.courses);

        if (selectedCModuleId && $scope.selectedCModule && selectedCModuleId !== $scope.selectedCModule.id) {
          setupFromIds(selectedCModuleId, selectedCourseId, selectedCatalogId);
        }

        $scope.viewState.showToggleButton = $scope.catalogList && $scope.catalogList.length > 0;

        setLastCModuleInCourse($scope.originalCModuleList);

        timers.updateDash = $timeout($scope.triggerResize);
      });
    }

    accountInfoDereg = $rootScope.$watch('accountInfo', function() {
      var hasCustomBrandingEnterpriseCSS;
      $scope.viewState.showViewAsTrainer = Auth.userIsTeamMember();
      $scope.viewState.hideMindflashBranding = $window.mfConfig.hideMindflashBranding;
      $scope.viewState.showLanguageSelector = !!~$window.mfConfig.features.indexOf(mtypes.featureEntry.localization);
      $scope.languageModel.languages = $window.mfConfig.languages || [];
      
      $scope.viewState.consoleIntegrationEnabled = !!~$window.mfConfig.features.indexOf(mtypes.featureEntry.consoleIntegration);

      hasCustomBrandingEnterpriseCSS = $window.mfConfig.hasCustomCSS || $window.mfConfig.hasCustomCompiledCss;

      if (!hasCustomBrandingEnterpriseCSS) {
        $scope.viewState.headerColor.background = $scope.accountInfo.headerBackgroundColor || $scope.viewState.headerColor.background;
        $scope.viewState.headerColor.link = $scope.accountInfo.headerLinkColor || $scope.viewState.headerColor.link;
        $scope.viewState.headerColor.text = $scope.accountInfo.headerTextColor || $scope.viewState.headerColor.text;
      }
    });

    $scope.changeLanguage = function() {
      selectedLanguage($scope.languageModel.selectedLanguage);
      gettextCatalog.setCurrentLanguage($scope.languageModel.selectedLanguage);

      // put text in view so we do not have to manually trigger the scope refresh
      var cModule = $scope.selectedCModule;
      if (cModule) {
        $scope.viewState.sensionInfoMessage = sensionRepository.infoMessage(cModule);
        $scope.viewState.sensionErrorMessage = sensionRepository.errorMessage(cModule);
      }
    };

    $scope.baseLocation = 'https://' + $window.location.host;

    $scope.$on('$viewContentLoaded', function() {
      trackingService.trackPageView($location.path());
    });

    $scope.getCModuleDetailViewUrl = function() {
      if ($scope.traineeCModuleList.length <= 0) {
        return dashboardConfig.cModuleDetailView.noCModuleView;
      }

      return dashboardConfig.cModuleDetailView.detailView;
    };

    $scope.logout = function() {
      serviceLocator.logout();
    };

    $scope.editProfile = function() {
      var consoleIntegration = false;
      if ($window.mfConfig && $window.mfConfig.features && $window.mfConfig.features.indexOf) {
        consoleIntegration = !!~$window.mfConfig.features.indexOf(mtypes.featureEntry.consoleIntegration);
      }
      if (consoleIntegration) return window.open($window.mfConfig.consoleIntegration.editUserProfileUri);
      trackingService.trackEvent(trackingService.pages.traineeDashboard.name, trackingService.pages.traineeDashboard.actions.editProfile);
      $modal.open({
        templateUrl: 'modals/modalEditProfile.html'
      });
    };

    $scope.switchAccounts = function() {
      $modal.open({
        templateUrl: 'modals/modalSwitchAccounts.html',
        controller: 'SwitchAccountsCtrl',
        scope: $scope
      });
    };

    $scope.companyInfo = function() {
      $modal.open({
        templateUrl: 'modals/modalCompanyInfo.html'
      });
    };

    function setLastCModuleInCourse(traineeCModuleList) {
      // find last cModule on course
      _.each(traineeCModuleList, function(cModuleList) {
        if (cModuleList.type === 'course') {
          var lastCModule = _.last(cModuleList.cModules) || {};
          lastCModule.lastCModule = true;
        }
      });
    }

    $scope.setup = function() {
      SpinnerHelper.showLoadingSpinner();
      dashLoad(function(result) {
        $scope.originalCModuleList = result.courses;
        $scope.unfilteredTraineeCModuleList = $scope.originalCModuleList;
        $scope.traineeCModuleList = $scope.originalCModuleList;
        $scope.catalogList = result.catalogs;
        $scope.viewState.isLoading = false;
        $scope.viewState.showToggleButton = $scope.catalogList && $scope.catalogList.length > 0;

        setLastCModuleInCourse($scope.traineeCModuleList);
        dashboardResource.getAssociatedAccounts(function(response) {
          $scope.showSwitch = response.accounts.length > 1;
        });

        setupNoCModuleMessage();
        setupExpandedCourse();
        $scope.getCModuleDetailViewUrl();
        setupFromQueryParams();
        storeSelectedCModule();
        setupCModuleHtmlValues();
        refreshViewStateData($scope.selectedCModule);

        SpinnerHelper.hideAllSpinners();

        $scope.$emit('scrollCModuleList', $scope.selectedCModule ? $scope.selectedCModule.id : 0);

        timers.setup = $timeout($scope.triggerResize, 200);

        // TODO: Iverson session timeout
        // updateDashPromise = $interval(updateDash, 30000);
      });
    };

    function setupExpandedCourse() {
      expandedCourseIds = dashboardStoreService.read('expandedCourseIds') || [];
      if (expandedCourseIds && expandedCourseIds.length > 0) {
        _.each($scope.traineeCModuleList, function(s) {
          if (s.type === 'course') {
            s.showCourseCModules = _.contains(expandedCourseIds, s.id);
          }
        });
      }
    }

    function setupFromQueryParams() {
      var selectedCatalogId = parseInt($location.search().selectedCatalogId);
      var selectedCModuleId = parseInt($location.search().selectedCModuleId);
      var selectedCourseId = parseInt($location.search().selectedCourseId);

      $scope.viewingCModuleInCatalog = !!$location.search().viewingCModuleInCatalog;

      setupFromIds(selectedCModuleId, selectedCourseId, selectedCatalogId);
    }

    function setupFromIds(selectedCModuleId, selectedCourseId, selectedCatalogId) {
      $scope.selectedCatalog = null;
      $scope.selectedCModule = null;
      $scope.selectedCourse = null;
      $scope.viewingCatalogCModuleList = null;
      $scope.viewingCatalogList = $location.search().viewingCatalogList;
      $scope.viewingCModuleInCatalog = null;
      $scope.viewingCModuleInCourse = null;
      $scope.viewingCourseCModuleList = null;

      if (!$scope.hasEnoughWidthForListAndDetailView()) {
        $scope.viewState.searchCriteria = $location.search().searchCriteria;

        if (selectedCatalogId || $scope.viewingCatalogList) {
          setupCatalogViewFromQueryParams({
            catalogId: selectedCatalogId,
            cModuleId: selectedCModuleId,
            courseId: selectedCourseId
          });
        } else if (selectedCourseId) {
          setupCourseViewFromQueryParams({
            cModuleId: selectedCModuleId,
            courseId: selectedCourseId
          });
        } else if (selectedCModuleId) {
          setupCModuleViewFromQueryParams({ cModuleId: selectedCModuleId });
        }

        if ($scope.viewingCatalogCModuleList || $scope.viewingCourseCModuleList) {
          $scope.viewState.style.cModuleListTopValue = '0';
        }
      } else {
        if (selectedCatalogId) {
          setupCatalogViewFromQueryParams({
            catalogId: selectedCatalogId,
            cModuleId: selectedCModuleId
          });
        } else if (selectedCModuleId) {
          setupCModuleViewFromQueryParams({ cModuleId: selectedCModuleId });
        }

        if (!restoreSelectedCModule()) {
          if ($scope.viewState.page.name === 'catalog') {
            refreshViewStateData($scope.selectedCatalog);
            $scope.selectedCModule = $scope.selectedCatalog;
          } else {
            $scope.selectedCModule = $scope.traineeCModuleList[0];
          }
        }
        restoreSelectedTab();
      }
    }

    function setupCatalogViewFromQueryParams(params) {
      var catalogId = params.catalogId;
      var cModuleId = params.cModuleId;
      var courseId = params.courseId;

      // Can get a course ID from phone view, only cModule ID ever from email.
      // Course may come in as cModule IDs from emails.
      var childItemId = courseId || cModuleId;

      setUpCatalogView(function() {
        $scope.selectedCatalog = _.findWhere($scope.catalogList, { catalogId: catalogId });
        $scope.viewingCatalogCModuleList = !!$location.search().viewingCatalogCModuleList && $scope.selectedCatalog !== null;
        if ($scope.selectedCatalog) {
          $scope.selectCatalog($scope.selectedCatalog, true);
          var selectedItemInCatalog = _.findWhere($scope.traineeCModuleList, { id: childItemId });
          if (selectedItemInCatalog) {
            // If somehow we have query parameters to view both a cModule/course in the catalog and see the cModule list, view the cModule/course.
            $scope.viewingCatalogCModuleList = false;
            if (selectedItemInCatalog.courseType !== mtypes.seriesType.none) {
              setupCourseViewFromQueryParams({
                cModuleId: cModuleId && cModuleId !== courseId ? cModuleId : null,
                courseId: childItemId
              });
            } else {
              setupCModuleViewFromQueryParams({ cModuleId: cModuleId });
            }
          }
        }

        if ($scope.viewingCatalogCModuleList || $scope.viewingCourseCModuleList) {
          $scope.viewState.style.cModuleListTopValue = '0';
          $scope.viewState.style.cModuleListBottomValue = '18px';
        }
      }, true);
    }

    function setupCourseViewFromQueryParams(params) {
      var cModuleId = params.cModuleId;
      var courseId = params.courseId;

      $scope.selectedCourse = _.findWhere($scope.traineeCModuleList, { id: courseId });
      $scope.viewingCourseCModuleList = !!$location.search().viewingCourseCModuleList && $scope.selectedCourse !== null;
      $scope.viewingCModuleInCourse = !!$location.search().viewingCModuleInCourse && $scope.selectedCourse !== null && !!cModuleId;

      if ($scope.selectedCourse) {
        $scope.selectCourse($scope.selectedCourse, true);

        if ($scope.viewingCourseCModuleList || $scope.viewingCModuleInCourse) {
          $scope.unfilteredTraineeCModuleList = $scope.selectedCourse.cModules;
          $scope.filterByState(null);
        }

        if ($scope.viewingCModuleInCourse && cModuleId) {
          setupCModuleViewFromQueryParams({ cModuleId: cModuleId });
        }
      }
    }

    function setupCModuleViewFromQueryParams(params) {
      var cModuleId = params.cModuleId;

      $scope.selectedCModule = _.findWhere($scope.traineeCModuleList, { id: cModuleId });
      $scope.viewingCModuleInCourse = $scope.viewingCModuleInCourse && !!$scope.selectedCModule;

      if ($scope.selectedCModule) {
        $scope.selectCModule($scope.selectedCModule, true);
        $scope.viewingCourseCModuleList = false;
      }
    }

    function setUpCatalogView(cb, keepSearchCriteria) {
      if (!$scope.hasEnoughWidthForListAndDetailView()) {
        $scope.selectedCatalog = null;
      }

      if (!keepSearchCriteria) {
        $scope.viewState.searchCriteria = null;
      }

      $scope.viewState.showCatalogBackButton = false;
      $scope.viewState.showCatalogListInfo = false;
      $scope.viewState.page.background = '#def2f8';
      $scope.viewState.page.name = 'catalog';
      $scope.viewState.page.header.text = gettext('Course Catalog');
      $scope.viewState.page.header.buttonText = gettext('My Courses');
      $scope.viewState.showSectionHeader = false;
      $scope.viewState.style.cModuleListTopValue = '36px';
      $scope.unfilteredTraineeCModuleList = $scope.catalogList;
      setupNoCModuleMessage();
      $scope.getCatalogInfo(_.pluck($scope.catalogList, 'catalogId'), function() {
        if ($scope.hasEnoughWidthForListAndDetailView()) {
          $scope.selectedCatalog = $scope.unfilteredTraineeCModuleList[0];
        }

        restoreSelectedCModule();
        refreshViewStateData($scope.selectedCatalog);
        $scope.selectedCModule = $scope.selectedCatalog;
        $scope.filterByState(null);

        if (cb) {
          return cb();
        }
      });
    }

    function setUpCModuleView() {
      $scope.viewState.showCatalogBackButton = false;
      $scope.viewState.showCatalogListInfo = false;
      $scope.viewState.page.background = '#def2f8';
      $scope.viewState.page.name = 'cModule';
      $scope.viewState.page.header.text = gettext('My Courses');
      $scope.viewState.page.header.buttonText = gettext('Course Catalog');
      $scope.viewState.showSectionHeader = true;
      $scope.viewState.style.cModuleListTopValue = '66px';
      $scope.viewState.style.cModuleListBottomValue = '0';
      $scope.unfilteredTraineeCModuleList = $scope.originalCModuleList;
      setupNoCModuleMessage();
      $scope.viewState.searchCriteria = null;
      restoreSelectedCModule();
      refreshViewStateData($scope.selectedCModule);
      $scope.filterByState(null);
    }

    $scope.gotoCatalogList = function() {
      setUpCatalogView(function() {
        if ($scope.catalogList.length === 1) {
          $scope.selectCatalog($scope.catalogList[0]);
          $scope.viewState.showCatalogBackButton = false;
        }
      });
    };

    $scope.gotoCatalog = function() {
      if ($scope.viewState.page.name === 'catalog') return;
      $scope.gotoCatalogList();
    };

    function setupNoCModuleMessage() {
      $scope.viewState.showNoCModuleMessage = !$scope.viewState.isLoading &&
        !$scope.viewState.searchCriteria &&
        (!$scope.unfilteredTraineeCModuleList || $scope.unfilteredTraineeCModuleList.length === 0);
    }

    $scope.gotoCModuleList = function() {
      if ($scope.viewState.page.name === 'cModule') return;
      setUpCModuleView();
    };

    $scope.togglePageView = function() {
      if ($scope.viewState.page.name === 'cModule') {
        $location.url($location.path());
        setUpCatalogView();
        $location.search({
          viewingCatalogList: true,
          searchCriteria: $scope.viewState.searchCriteria
        });
      } else {
        $location.url($location.path());
        setUpCModuleView();
      }
    };

    function restoreSelectedTab() {
      var state = dashboardStoreService.read('state') || 'all';

      if (state !== 'all' && $scope.selectedCModule) {
        var testCModule = $scope.selectedCModule;
        if (testCModule.courseId) {
          testCModule = _.find($scope.originalCModuleList, function(s) {
            return s.id === testCModule.courseId;
          });
        }
        if (testCModule.status !== 'completed') {
          state = 'inProgress';
        } else {
          state = 'completed';
        }
      }

      if (state) {
        $scope.filterByState(state);
      }
    }

    function storeSelectedCModule() {
      var info;
      if (!$scope.selectedCModule) {
        dashboardStoreService.save('selectedCModule', {});
        return;
      }

      info = dashboardStoreService.read('selectedCModule');

      if ($scope.selectedCModule.type === 'course') {
        dashboardStoreService.save('selectedCModule', {
          courseId: $scope.selectedCModule.id,
          cModuleId: info && info.cModuleId ? info.cModuleId : null,
          catalogId: info && info.catalogId ? info.catalogId : null
        });
      } else if ($scope.selectedCModule.type === 'catalog') {
        dashboardStoreService.save('selectedCModule', {
          catalogId: $scope.selectedCModule.catalogId,
          cModuleId: info && info.cModuleId ? info.cModuleId : null,
          courseId: info && info.courseId ? info.courseId : null
        });
      } else {
        dashboardStoreService.save('selectedCModule', {
          courseId: $scope.selectedCModule.courseId,
          cModuleId: $scope.selectedCModule.id,
          catalogId: info && info.catalogId ? info.catalogId : null
        });
      }
    }

    function restoreSelectedCModule() {
      var info;
      var course;
      var cModule;
      var catalog;
      var cModules;
      var catalogs;

      if ($routeParams['selectedCModuleId'] !== undefined && !$scope.hasEnoughWidthForListAndDetailView()) {
        return true;
      }

      info = dashboardStoreService.read('selectedCModule');

      if (!info || (!info.courseId && !info.cModuleId)) {
        return false;
      }

      if (info.courseId) {
        course = _.find($scope.originalCModuleList, function(f) {
          return f.id === info.courseId && f.type === 'course';
        });
      }

      cModules = course ? course.cModules : $scope.originalCModuleList;
      catalogs = $scope.catalogList;

      if (info.cModuleId) {
        cModule = _.find(cModules, function(f) {
          return f.id === info.cModuleId;
        });
      }

      if (info.catalogId) {
        catalog = _.find(catalogs, function(f) {
          return f.catalogId === info.catalogId;
        });
      }

      if (info.cModuleId && !cModule && !course) {
        var allCourse = _.filter($scope.originalCModuleList, function(i) {
          return i.type === 'course';
        });

        if (allCourse && allCourse.length > 0) {
          for (var index = 0; index < allCourse.length; index++) {
            var testCourse = allCourse[index];
            var testCModule = _.find(testCourse.cModules, function(s) {
              return s.id === info.cModuleId;
            });
            if (testCModule) {
              course = testCourse;
              cModule = testCModule;
              break;
            }
          }
        }
      }

      if (catalog) {
        $scope.selectedCatalog = catalog;
      }

      if (course) {
        course.showCourseCModules = true;
      }

      if (cModule) {
        $scope.selectedCModule = cModule;
        return true;
      } else if (course) {
        $scope.selectedCModule = course;
        return true;
      }

      return false;
    }

    $scope.goBack = function() {
      var searchParams = {};
      if ($scope.viewingCModuleInCourse) {
        if ($scope.selectedCatalog) {
          searchParams.selectedCatalogId = $scope.selectedCatalog.catalogId;
        }
        searchParams.selectedCModuleId = $scope.selectedCourse.id;
        searchParams.selectedCourseId = $scope.selectedCourse.id;
        searchParams.viewingCourseCModuleList = true;
      } else if ($scope.viewingCourseCModuleList) {
        if ($scope.selectedCatalog) {
          searchParams.selectedCatalogId = $scope.selectedCatalog.catalogId;
          searchParams.viewingCModuleInCatalog = true;
        }
        searchParams.selectedCModuleId = $scope.selectedCModule.id;
      } else if ($scope.viewingCModuleInCatalog) {
        searchParams.selectedCatalogId = $scope.selectedCatalog.catalogId;
        searchParams.viewingCatalogCModuleList = true;
      } else if ($scope.viewingCatalogCModuleList) {
        searchParams.viewingCatalogList = true;
      } else if ($scope.selectedCatalog) {
        searchParams.viewingCatalogList = true;
      }
      searchParams.searchCriteria = $scope.viewState.searchCriteria;

      $location.search(searchParams);

      // In case they've switched from tablet mode to phone mode in some weird combination they may end up not
      // having the query string change and thus the page doesn't reload. For this case we need to just manually
      // call setup to end up where we want to be.
      $scope.setup();
    };

    $scope.getGoBackLabel = function() {
      if ($scope.viewingCModuleInCourse) {
        return translate(gettext('Back to all modules in course'));
      } else if ($scope.viewingCourseCModuleList) {
        return translate(gettext('Back to %s'), $scope.selectedCourse.name);
      } else if ($scope.viewingCModuleInCatalog && $scope.selectedCatalog) {
        return translate(gettext('Back to %s'), $scope.selectedCatalog.name);
      } else if ($scope.selectedCatalog || $scope.viewingCatalogCModuleList) {
        return translate(gettext('Back to all catalogs'));
      }
      return translate(gettext('Back to Home'));
    };

    $scope.getDeadlineMessage = function(cModule) {
      if (!cModule || !cModule.type || !cModule.completionDeadlineLength || !cModule.completiondeadlineTimeUnit) return;

      if (cModule.type === 'cModule' || cModule.type === 'online') {
        if (cModule.completiondeadlineTimeUnit === 'day') {
          return 'cModuleDay';
        } else if (cModule.completiondeadlineTimeUnit === 'week') {
          return 'cModuleWeek';
        }
      } else if (cModule.type === 'course') {
        if (cModule.completiondeadlineTimeUnit === 'day') {
          return 'courseDay';
        } else if (cModule.completiondeadlineTimeUnit === 'week') {
          return 'courseWeek';
        }
      }
    };

    $scope.scoreClass = function(cModule) {
      if (!cModule) return '';
      if (hasNewCourse) {
        if (cModule.gradeStatus === 'failed') return 'failed';
        if (cModule.score === null) return 'fa fa-check checkMark';
        return 'passed';
      }

      if (cModule.type === 'course' && cModule.score !== null && isCourseWithQuizzes(cModule)) {
        return cModule.gradeStatus === 'failed' ? 'failed' : 'passed';
      }
      return gradeStatusClass[cModule.gradeStatus];
    };

    $scope.selectCModule = function(cModule, skipUpdateQueryParams) {
      if (!$scope.hasEnoughWidthForListAndDetailView() && !skipUpdateQueryParams) {
        var searchParams = {
          searchCriteria: $scope.viewState.searchCriteria,
          selectedCModuleId: cModule.id
        };
        if ($scope.viewingCourseCModuleList) {
          searchParams.selectedCourseId = $scope.selectedCModule.id;
          searchParams.viewingCModuleInCourse = true;
          if ($scope.viewingCModuleInCatalog) {
            searchParams.viewingCModuleInCatalog = true;
          }
        } else if ($scope.viewingCatalogCModuleList) {
          searchParams.viewingCModuleInCatalog = true;
        }

        if ($scope.selectedCatalog) {
          searchParams.selectedCatalogId = $scope.selectedCatalog.catalogId;
        }

        $location.search(searchParams);
      }

      $scope.selectedCModule = cModule;

      // Do not store in cookie if catalog cModule/course
      if (!$scope.selectedCModule.catalogId) {
        storeSelectedCModule();
      }

      refreshViewStateData(cModule);
    };

    // $scope.getToggleArrowClass = function (course) {
    //  return course.showCourseCModules ? "fa fa-caret-down" : "fa fa-caret-right";
    // };

    $scope.selectCourse = function(course, skipUpdateQueryParams) {
      if (!$scope.hasEnoughWidthForListAndDetailView() && !skipUpdateQueryParams) {
        var searchParams = {
          searchCriteria: $scope.viewState.searchCriteria,
          selectedCModuleId: course.id
        };
        if ($scope.viewingCatalogCModuleList) {
          searchParams.selectedCatalogId = $scope.selectedCModule.catalogId;
          searchParams.viewingCModuleInCatalog = true;
        }
        $location.search(searchParams);
      }

      expandCourse(course);
      $scope.selectedCModule = course;

      // Do not store in cookie if catalog cModule/course
      if (!$scope.selectedCModule.catalogId) {
        storeSelectedCModule();
      }

      refreshViewStateData(course);

      $scope.viewState.course.numOfCompletedCModule = _.filter(course.cModules, function(item) {
        return item.status === 'completed';
      }).length;
      $scope.viewState.course.totalCModules = course.cModules.length;
    };

    $scope.selectCatalog = function(catalog, skipUpdateQueryParams) {
      if (!$scope.hasEnoughWidthForListAndDetailView() && !skipUpdateQueryParams) {
        if (catalog.catalogCModuleSearchMatches &&
          (!$scope.viewState.searchCriteria || !~catalog.name.indexOf($scope.viewState.searchCriteria))) {
          $scope.viewCatalogCModules(catalog);
        } else {
          $location.search({
            searchCriteria: $scope.viewState.searchCriteria,
            selectedCatalogId: catalog.catalogId
          });
        }
      }

      $scope.unfilteredTraineeCModuleList = catalog.cModules;
      $scope.viewState.showCatalogBackButton = $scope.catalogList.length !== 1;
      $scope.viewState.showCatalogListInfo = true;
      $scope.viewState.style.cModuleListTopValue = $scope.catalogList.length === 1 ? '76px' : '116px';
      $scope.viewState.style.cModuleListBottomValue = '18px';
      $scope.viewState.catalog.selected = catalog;
      $scope.selectedCModule = catalog;
      refreshViewStateData(catalog);
      storeSelectedCModule();
      $scope.filterByState(null);
    };

    function expandCourse(course) {
      if (!$scope.hasEnoughWidthForListAndDetailView()) {
        return;
      }

      course.showCourseCModules = !course.showCourseCModules;

      // TODO: Iverson investigate issue from refactor as to why it was commented out
      updateExpandedCourse(course);
      refreshViewStateData(course);
    }

    function updateExpandedCourse(course) {
      if (course.showCourseCModules) {
        expandedCourseIds = _.union(expandedCourseIds, [course.id]);
      } else {
        expandedCourseIds = _.without(expandedCourseIds, course.id);
      }

      dashboardStoreService.save('expandedCourseIds', expandedCourseIds);
    }

    function showFailedMessage(course) {
      if (!course) {
        return false;
      }
      return course.failureEnforced && course.gradeStatus === 'failed' && course.score == null;
    }

    function refreshViewStateData(cModule) {
      if (cModule) {
        var course;
        if (cModule.type === 'course') {
          course = cModule;
        } else {
          course = _.findWhere($scope.traineeCModuleList, { id: cModule.courseId });
        }

        $scope.selectedCModuleCourse = course;
        $scope.viewState.showDeadline = getShowDeadline(cModule.status, cModule.completionDeadline);
        $scope.viewState.catalog.showDeadlineMessage = cModule.status === 'canEnroll' && cModule.completionDeadlineLength && cModule.completionDeadlineLength > 0;
        $scope.viewState.showScore = cModule.status === 'completed';
        $scope.viewState.showScorePercent = cModule.score !== null;
        $scope.viewState.showPassingScore = cModule.hasPassingScore && cModule.status !== 'completed';
        $scope.viewState.buttonText = getButtonText(cModule.status, cModule.type);
        $scope.viewState.completionTextStyle = cModule.gradeStatus === 'failed' ? 'failed' : 'completed';
        $scope.viewState.completionText = getCompletionText(cModule.gradeStatus);
        $scope.viewState.cModuleArchivedOrDeleted = cModule.cModuleStatus === mtypes.cModuleStatus.archive || cModule.deleted;
        $scope.viewState.retakeOutsideCourse = cModule.retakeOutsideCourse && !$scope.viewState.cModuleArchivedOrDeleted;
        $scope.viewState.showCModuleActionButton = getShowCModuleActionButton(cModule);
        $scope.viewState.showCourseUpdatedMessage = !!cModule.isCourseUpdated && cModule.status === 'completed' && cModule.type && cModule.type.toLowerCase() === 'course';
        $scope.viewState.showCModuleActionButton = $scope.viewState.showCModuleActionButton && !$scope.viewState.showCourseUpdatedMessage;
        $scope.viewState.missedDeadline = cModule.status === 'missedcompletiondeadline' && !cModule.catalogId;
        $scope.viewState.showSensionInfo = sensionRepository.showInfo(cModule);
        $scope.viewState.sensionInfoMessage = sensionRepository.infoMessage(cModule);
        $scope.viewState.showSensionError = sensionRepository.showError(cModule);
        $scope.viewState.showCourseFailedMessage = cModule.type === 'course' && showFailedMessage(course);
        $scope.viewState.showCModuleFailedMessage = cModule.type === 'online' && showFailedMessage(course) && cModule.gradeStatus === 'failed' && !cModule.lastCModule;
        $scope.viewState.sensionErrorMessage = sensionRepository.errorMessage(cModule);
        $scope.viewState.showDrop = getDropStatus(cModule);
        $scope.viewState.showRetake = getRetakeStatus(cModule);
        $scope.viewState.showCertificate = cModule.certificateId && cModule.certificate;
        $scope.viewState.orderEnforced = !!cModule.orderEnforced;
        $scope.viewState.failureEnforced = !!(cModule.failureEnforced && cModule.gradeStatus !== 'failed');

        $scope.viewState.alteredAfterCompletionMessage = !!cModule.alteredCourse;
        $scope.viewState.completionDeadline = cModule.completionDeadline || null;
        $scope.viewState.showCModuleStateView = cModule.type !== 'catalog';

        if (course) {
          $scope.viewState.trainerImageUrl = course.trainerImageUrl;
          $scope.viewState.trainerName = course.trainerName;
          $scope.viewState.trainerEmail = course.trainerEmail;
        }
      }

      $scope.scrollCModuleDetailsToTop();
    }

    $scope.getCModuleTrainerStyle = function(cModule) {
      if (!cModule) {
        return;
      }
      if (cModule.status === 'canEnroll') {
        return {
          border: 'none'
        };
      }
    };

    function isCourseWithQuizzes(course) {
      var cModuleWithQuizFound = _.find(course.cModules, function(cModule) {
        return cModule.gradeStatus !== 'notapplicable';
      });
      return !!cModuleWithQuizFound;
    }

    function getRetakeStatus(item) {
      if(item.type === 'live') {
        return false;
      }

      if (item.canRetake) {
        return true;
      }

      return !!(item.retakeEnabled && item.completed && item.completeDaysLeft >= 0);
    }

    function getDropStatus(cModule) {
      return cModule.type === 'course' && !cModule.required && cModule.status !== 'completed';
    }

    function getButtonText(status, type) {
      if (type === 'online' || type.toLowerCase() === 'cmodule') {
        type = 'Module';
      } else {
        type = type.charAt(0).toUpperCase() + type.slice(1);
      }

      if (status === 'invited') {
        return gettext('Get Started');
      } else if (status === 'started') {
        return sprintf('Resume %s', type);
      } else if (status === 'completed') {
        return sprintf('Review %s', type);
      } else if (status === 'canEnroll') {
        return gettext('Enroll');
      }
    }

    function getCompletionText(gradeStatus) {
      if (!hasNewCourse) {
        return gettext('Completed');
      }
      if (gradeStatus === 'failed') {
        return gettext('Failed');
      }
      return gettext('Passed');
    }

    function getShowDeadline(status, completionDeadline) {
      return !!((status !== 'completed') && completionDeadline);
    }

    $scope.showDeadlineWarning = function(cModule) {
      if (cModule.catalogId && cModule.catalogId !== null) {
        return false;
      }

      if (cModule.status === 'missedcompletiondeadline') {
        return true;
      }
      if (cModule.completionDeadline) {
        if (cModule.status === 'completed') {
          return false;
        }
        if (cModule.completeDaysLeft <= 3) {
          return true;
        }
      }
      return false;
    };

    $scope.showCheckMark = function(cModule) {
      return cModule.status !== 'canEnroll' && cModule.cModuleType === 'catalog';
    };

    $scope.deadlineClass = function(cModule) {
      if (!cModule) {
        return '';
      }
      if (cModule.status === 'missedcompletiondeadline') {
        return 'red';
      } else if (cModule.completionDeadline) {
        if (cModule.completeDaysLeft <= 3) {
          return 'orange';
        }
        return undefined;
      }
    };

    function getShowCModuleActionButton(cModule) {
      var nextCModuleInCourse = null;
      if(cModule.type === 'catalog') {
        return false;
      }

      if (cModule.type === 'course') {
        nextCModuleInCourse = dashboardHelper.getNextCModuleInCourse(cModule);
      }

      if (cModule.status === 'canEnroll' && (cModule.type === 'cModule' || cModule.type === 'online') && cModule.courseId) {
        return false;
      }

      if (cModule.retakeOutsideCourse) {
        return false;
      }

      if (cModule.deleted || cModule.cModuleStatus === mtypes.cModuleStatus.archive) {
        return false;
      }

      if (cModule.type === 'live' || nextCModuleInCourse && nextCModuleInCourse.type === 'live') {
        return false;
      }

      if (cModule.type === 'filerequest' || nextCModuleInCourse && nextCModuleInCourse.type === 'filerequest') {
        return false;
      }

      return cModule.status !== 'missedcompletiondeadline';
    }

    $scope.gotoCModule = function(cModule) {
      var userId;
      var date;
      var dateString;

      if (!cModule) {
        return;
      }

      if (cModule.status === 'canEnroll') {
        userId = $window.mfConfig.userId;
        date = new Date();
        dateString = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

        dashboardResource.enrollTraineeToCourse(cModule.id, dateString, function() {
          navigateToCModulePlayer(cModule);
        });
      } else {
        dashboardStoreService.save('state', cModule.status === 'completed' ? 'completed' : 'inProgress');
        navigateToCModulePlayer(cModule, true);
      }
    };

    function navigateToCModulePlayer(cModule, trackGetStartedEvent) {
      var player2019 = !!~$window.mfConfig.features.indexOf(mtypes.featureEntry.player2019);
      var newCModule = cModule.type === 'course' ? dashboardHelper.getNextCModuleInCourse(cModule) : cModule;

      // course without cModules
      if (!newCModule) {
        return;
      }

      if (trackGetStartedEvent && newCModule.status === 'invited') {
        trackingService.trackEvent(trackingService.pages.traineeDashboard.name, trackingService.pages.traineeDashboard.actions.getStarted);
      }

      if (newCModule.cModuleId) {
        newCModule.id = newCModule.cModuleId;
      }

      if (!player2019) {
        return $location.path('/player/module/' + newCModule.id + '/course/' + newCModule.courseId).search({ courseId: newCModule.courseId });
      }

      $window.location = 'https://' + $window.location.host + '/player/cmodule/' + newCModule.id + '/course/' + newCModule.courseId;
    }

    $scope.selectedCModuleClass = function(item) {
      return item === $scope.selectedCModule || item === $scope.selectedCatalog ? 'active' : undefined;
    };

    function setupCModuleHtmlValues() {
      _.each($scope.traineeCModuleList, function(cModule) {
        setHtmlForItem(cModule);
        _.each(cModule.cModules, function(courseCModule) {
          setHtmlForItem(courseCModule);
        });
      });
    }

    function setHtmlForItem(item) {
      var lastCharacterUsed;
      var lastIndexOf;
      if (!$scope.viewState.searchCriteria || $scope.viewState.searchCriteria.length === 0) {
        item.htmlValue = _.escape(item.name);
      } else {
        item.htmlValue = '';
        lastCharacterUsed = 0;
        lastIndexOf = _.escape(item.name.toLowerCase().indexOf($scope.viewState.searchCriteria.toLowerCase(), lastCharacterUsed));
        while (lastIndexOf >= 0) {
          item.htmlValue = item.htmlValue + _.escape(item.name.substring(lastCharacterUsed, lastIndexOf)) +
            '<u>' + _.escape(item.name.substring(lastIndexOf, lastIndexOf + $scope.viewState.searchCriteria.length)) + '</u>';
          lastCharacterUsed = lastIndexOf + $scope.viewState.searchCriteria.length;
          lastIndexOf = _.escape(item.name.toLowerCase().indexOf($scope.viewState.searchCriteria.toLowerCase(), lastCharacterUsed));
        }
        item.htmlValue = item.htmlValue + _.escape(item.name.substring(lastCharacterUsed));
      }

      if ((item.courseCModuleSearchMatches && !$scope.hasEnoughWidthForListAndDetailView()) || item.catalogCModuleSearchMatches) {
        item.htmlValue = item.htmlValue + '<i class="fa fa-level-down"></i>';
      }

      item.trustedHtmlValue = item.htmlValue;
    }

    function matchesOnChildName(item, propertyName) {
      return _.filter(item[propertyName], function(itemChild) {
        return !!~itemChild.name.toLowerCase().indexOf($scope.viewState.searchCriteria.toLowerCase());
      }).length > 0;
    }

    function matchesOnCatalogChildren(item) {
      if (item.cModules && item.cModules.length > 0) {
        _.each(item.cModules, matchOnCourseChildren);
        item.catalogCModuleSearchMatches = matchesOnChildName(item, 'cModules') ||
          _.where(item.cModules, { courseCModuleSearchMatches: true }).length > 0;
      } else {
        item.catalogCModuleSearchMatches = false;
      }

      // If we have a selected catalog and got here this means we're in phone mode and
      // the search criteria matched some child of the catalog.
      if (!$scope.hasEnoughWidthForListAndDetailView() && $scope.selectedCatalog) {
        return true;
      }

      return item.catalogCModuleSearchMatches;
    }

    function matchOnCourseChildren(item) {
      if (item.cModules && item.cModules.length > 0) {
        item.courseCModuleSearchMatches = matchesOnChildName(item, 'cModules');
      } else {
        item.courseCModuleSearchMatches = false;
      }

      // If we have a selected course and got here this means we're in phone mode and
      // the search criteria matched some child of the course.
      if (!$scope.hasEnoughWidthForListAndDetailView() && $scope.selectedCourse) {
        return true;
      }

      return item.courseCModuleSearchMatches;
    }

    $scope.filterByState = function(state) {
      var filteredCModuleList = $scope.unfilteredTraineeCModuleList || [];
      var filteredCourseToExpand = [];
      var matchesOnRootName;
      var matchesOnCatalogChildName;
      var matchesOnCourseChildName;
      var filteredInProgressCModuleList;
      var filteredCompletedCModuleList;

      if ($scope.viewState.searchCriteria && $scope.viewState.searchCriteria.length > 0) {
        filteredCModuleList = _.filter(filteredCModuleList, function(item) {
          matchesOnRootName = !!~item.name.toLowerCase().indexOf($scope.viewState.searchCriteria.toLowerCase());
          matchesOnCatalogChildName = matchesOnCatalogChildren(item);
          matchesOnCourseChildName = matchOnCourseChildren(item);

          if (matchesOnCourseChildName) {
            filteredCourseToExpand.push(item);
          }

          return matchesOnRootName || matchesOnCatalogChildName || matchesOnCourseChildName;
        });
      } else {
        _.each(filteredCModuleList, function(item) {
          if (item.courseCModuleSearchMatches) {
            item.courseCModuleSearchMatches = false;
          }
          if (item.catalogCModuleSearchMatches) {
            item.catalogCModuleSearchMatches = false;
          }
        });
      }

      // cModule count
      $scope.viewState.allCModuleCount = filteredCModuleList.length;
      filteredInProgressCModuleList = _.filter(filteredCModuleList, function(item) {
        return item.status !== 'completed';
      });
      $scope.viewState.invitedCModuleCount = filteredInProgressCModuleList.length;
      filteredCompletedCModuleList = _.filter(filteredCModuleList, function(item) {
        return item.status === 'completed';
      });
      $scope.viewState.completedCModuleCount = filteredCompletedCModuleList.length;

      if (state === 'inProgress') {
        $scope.traineeCModuleList = filteredInProgressCModuleList;
        $scope.currentState = state;
      } else if (state === 'completed') {
        $scope.traineeCModuleList = filteredCompletedCModuleList;
        $scope.currentState = state;
      } else {
        $scope.currentState = 'all';
        $scope.traineeCModuleList = filteredCModuleList;
      }

      if ($scope.viewState.searchCriteria && $scope.viewState.searchCriteria.length > 0) {
        _.each($scope.traineeCModuleList, function(cModuleOrCourse) {
          // Expand course that need expanding.
          if (!!~filteredCourseToExpand.indexOf(cModuleOrCourse) && !cModuleOrCourse.showCourseCModules) {
            expandCourse(cModuleOrCourse);
          } else if (!~filteredCourseToExpand.indexOf(cModuleOrCourse) && cModuleOrCourse.cModules &&

            // Collapse course that should no longer be expanded based on search criteria.
            cModuleOrCourse.cModules.length > 0 && cModuleOrCourse.showCourseCModules) {
            expandCourse(cModuleOrCourse);
          }
        });
      }

      setupCModuleHtmlValues();

      dashboardStoreService.save('state', $scope.currentState);
    };

    $scope.retake = function(cModule) {
      if (!cModule.id) {
        return;
      }

      // Default android browser seems to send 2 events in relatively short order and the second one closes the modal.
      // The second event seems to not be on the button though so it's hard to capture. Thus, just wait a bit before
      // showing the modal. Yes, this solution sucks but I haven't found anything better. ng-click doesn't even get
      // into here.
      if (MobileHelper.isAndroid()) {
        $timeout(function() {
          retake(cModule);
        }, 400);
      } else {
        retake(cModule);
      }
    };

    function retake(cModule) {
      var modalInstance = $modal.open({
        templateUrl: 'modals/messageBox.html',
        controller: 'RetakeCModuleCtrl',
        scope: $scope
      });

      modalInstance.result.then(function() {
        $scope.gotoCModule(cModule);
      });
    }

    $scope.drop = function(cModule) {
      if (!cModule.id) return;

      // Default android browser seems to send 2 events in relatively short order and the second one closes the modal.
      // The second event seems to not be on the button though so it's hard to capture. Thus, just wait a bit before
      // showing the modal. Yes, this solution sucks but I haven't found anything better. ng-click doesn't even get
      // into here.
      if (MobileHelper.isAndroid()) {
        $timeout(function() {
          drop();
        }, 400);
      } else {
        drop();
      }
    };

    function drop() {
      var modalInstance = $modal.open({
        templateUrl: 'modals/messageBox.html',
        controller: 'DropCModuleCtrl',
        scope: $scope
      });

      modalInstance.result.then(function() {
        if ($scope.viewState.page.name === 'catalog') {
          updateDash();
          $scope.gotoCatalogList();
        } else {
          $scope.setup();
        }
      });
    }

    $scope.getHeaderTabClass = function(state) {
      return state === $scope.currentState ? 'active' : '';
    };

    $scope.downloadCertificate = function(certificateUrl) {
      Utils.downloadCertificate(certificateUrl);
    };

    $scope.showCompanyInfoModal = function() {
      $modal.open({
        templateUrl: 'modals/modalCompanyInfo.html',
        scope: $scope
      });
    };

    $scope.getCModuleAndCourseSelectionStateClasses = function() {
      var classes = '';
      if ($scope.viewingCourseCModuleList) {
        classes = classes + ' viewing-course-cmodules';
      } else if ($scope.viewingCatalogCModuleList) {
        classes = classes + ' viewing-catalog-cmodules';
      } else if ($scope.selectedCModule || $scope.selectedCatalog) {
        classes = classes + ' cmodule-selected';
      } else {
        classes = classes + ' cmodule-not-selected';
      }

      if ($scope.viewingCModuleInCourse) {
        classes = classes + ' viewing-cmodule-in-course';
      }

      if ($scope.viewState.isLoading &&
        ($scope.hasEnoughWidthForListAndDetailView && !$scope.hasEnoughWidthForListAndDetailView())) {
        classes = classes + ' hide';
      }

      if ($scope.viewState.showCatalogListInfo) {
        classes = classes + ' catalog-list-view';
      }

      return classes;
    };

    $scope.viewCourseCModules = function(course) {
      $location.search({
        selectedCourseId: course.id,
        viewingCourseCModuleList: true,
        viewingCModuleInCatalog: $scope.viewingCModuleInCatalog ? true : null,
        selectedCatalogId: $scope.selectedCatalog ? $scope.selectedCatalog.catalogId : null,
        searchCriteria: $scope.viewState.searchCriteria
      });
    };

    $scope.viewCatalogCModules = function(catalog) {
      $location.search({
        selectedCatalogId: catalog.catalogId,
        viewingCatalogCModuleList: true,
        searchCriteria: $scope.viewState.searchCriteria
      });
    };

    $scope.trainerDashboardLinkText = function() {
      if ($window.mfConfig.isIpad) {
        return '';
      }

      var roles = Auth.userRoles;
      if (Auth.userHasRole(roles.administrator) || Auth.userHasRole(roles.owner)) {
        return translate(gettext('View Administrator dashboard'));
      }
      if (Auth.userHasRole(roles.trainer)) {
        return translate(gettext('View Trainer dashboard'));
      }
      if (Auth.userHasRole(roles.manager)) {
        return translate(gettext('View Manager dashboard'));
      }
      if (Auth.userHasRole(roles.teamLead)) {
        return translate(gettext('View Team Lead dashboard'));
      }
      if (Auth.userHasRole(roles.reporter)) {
        return translate(gettext('View Reporter dashboard'));
      }
      return '';
    };

    $scope.clearSearchCriteria = function() {
      $scope.viewState.searchCriteria = null;
      $rootScope.$emit('initPlaceholders');
    };

    function setupSelectedAccount(cb) {
      var selectedCModuleId;
      if (!$routeParams.sessId || $routeParams.sessId === '0') {
        return cb();
      }

      if (updateDashPromise) {
        $interval.cancel(updateDashPromise);
      }
      Auth.clear();
      selectedCModuleId = $routeParams.selectedCModuleId;

      // 1.7 release fixes this so that the query parameters are correctly separated by "&" instead of "&amp;"
      // but to make users of older versions have a good experience check "amp;selectedCModuleId" param too.
      // Can delete when we block users of older versions of the native app.


      if (!selectedCModuleId) {
        selectedCModuleId = $routeParams['amp;selectedCModuleId'];
      }

      Auth.setHeaderSessionId($routeParams.sessId);
      AuthService.getDomain(function resultCb1(result1) {
        Auth.setDomain(result1.traineeDomain);
        Auth.setSelectedAccount($window.mfConfig);
        $rootScope.accountInfo = $window.mfConfig;
        $scope.selectedAccount = Auth.getSelectedAccount();
        if ($scope.selectedAccount.role === Auth.userRoles.sme ||
          $scope.selectedAccount.role === Auth.userRoles.anonymous) {
          previewCModule($routeParams.selectedCModuleId);
        } else {
          return cb();
        }
      });
    }

    function previewCModule(cModuleId) {
      QuizAnswerStorage.clearPreviewAnswers();
      SpinnerHelper.showLoadingSpinner();
      $location.path('/preview/' + cModuleId);
    }

    $scope.getCatalogInfo = function(catalogIds, cb) {
      if (!catalogIds) {
        return;
      }
      SpinnerHelper.showLoadingSpinner();
      dashboardResource.getCatalogInfo(catalogIds, function(result) {
        // combine catalog cModules
        _.each($scope.catalogList, function(list) {
          var catalogCModules = _.filter(result.catalogCModules, function(cModule) {
            return list.catalogId === cModule.catalogId;
          });
          if (catalogCModules && catalogCModules.length > 0) {
            list.cModules = catalogCModules[0].courses;
          }
        });


        $scope.viewState.catalog.isLoading = false;
        SpinnerHelper.hideAllSpinners();
        if (cb) {
          return cb();
        }
      });
    };

    $scope.$watch('viewState.searchCriteria', function() {
      if (!$scope.viewState.isLoading &&
        ($scope.hasEnoughWidthForListAndDetailView() || (!$scope.selectedCModule && !$scope.selectedCourse))) {
        updateFilter();
      }
    });

    function updateFilter() {
      $scope.filterByState($scope.currentState);
    }

    $scope.goToPrivacyPolicy = function() {
      Utils.viewUrlInBrowser('https://learn.trakstar.com/privacy-policy/');
    };

    function setupWhenReady() {
      // check to see if the directive is available
      if ($scope.hasEnoughWidthForListAndDetailView) {
        $scope.setup();
      } else {
        $timeout(setupWhenReady, 50);
      }
    }

    SpinnerHelper.showLoadingSpinner();
    $rootScope.$emit('initPlaceholders');
    Sension.isCompatible(function(isCompatible, err) {
      sensionRepository.deviceSupportsSension = isCompatible;
      sensionRepository.sensionError = err;
      setupSelectedAccount(function() {
        setupWhenReady();
      });
    });

    $scope.$on('$destroy', function() {
      _.each(timers, function(promise) {
        $timeout.cancel(promise);
      });

      if (updateDashPromise) {
        $interval.cancel(updateDashPromise);
      }
      accountInfoDereg();
    });
  }
})();
